import { ForwardIcon } from "@heroicons/react/24/outline"

export default function KinesisProgramWeekCompletionStatusIcon({ 
    displaySize = 'small', 
    weekCompletionStatusIconKey 
}) {
    if (displaySize === 'small') {
        return (
            <div className='relative'>
                <div className='h-5 w-5 rounded-full' />

                <div className='absolute top-0 left-0 h-5 w-5'>

                    {weekCompletionStatusIconKey === 'past-skipped' && 
                        <ForwardIcon className="-my-0.5 -ml-[2px] w-6 h-6 text-gray-400" />
                    }

                    {weekCompletionStatusIconKey === 'past-incomplete' && 
                        <svg width="20" height="20" style={{display: "block"}} viewBox="0 0 20 20">
                            <circle cx="10" cy="10" r="8.5" fill="transparent" stroke="#fb7185" strokeWidth="2.5"/> {/* Outer red ring */}
                            <circle cx="10" cy="10" r="5" fill="#fb7185"/> {/* Inner red circle */}
                        </svg>
                    }

                    {weekCompletionStatusIconKey === 'past-half-complete' && 
                        <svg width="20" height="20" style={{display: "block"}} viewBox="0 0 20 20">
                            <circle cx="10" cy="10" r="8.5" fill="transparent" stroke="#facc15" strokeWidth="2.5"/> {/* Outer yellow ring */}
                            <circle cx="10" cy="10" r="5" fill="#facc15"/> {/* Inner yellow circle */}
                        </svg>
                    }

                    {weekCompletionStatusIconKey === 'past-complete' && 
                        <svg width="20" height="20" style={{display: "block"}} viewBox="0 0 20 20">
                            <circle cx="10" cy="10" r="8.5" fill="transparent" stroke="#4ade80" strokeWidth="2.5"/> {/* Outer green ring */}
                            <circle cx="10" cy="10" r="5" fill="#4ade80"/> {/* Inner green circle */}
                        </svg>
                    }

                    {weekCompletionStatusIconKey === 'active-skipped' && 
                        <ForwardIcon className="-my-0.5 -ml-[2px] w-6 h-6 text-gray-400" />
                    }

                    {weekCompletionStatusIconKey === 'active' && 
                        <svg width="20" height="20" style={{display: "block"}} viewBox="0 0 20 20">
                            <circle cx="10" cy="10" r="8.5" fill="transparent" stroke="#99a1af" strokeWidth="2.5"/>
                        </svg>
                    }

                    {weekCompletionStatusIconKey === 'future' && 
                        <svg width="20" height="20" style={{display: "block"}} viewBox="0 0 20 20">
                            <circle cx="10" cy="10" r="8.5" fill="transparent" stroke="#99a1af" strokeWidth="2.5"/>
                        </svg>
                    }

                    {/* Faded */}
                    {/* {weekCompletionStatusIconKey === 'future' && 
                        <svg width="20" height="20" style={{display: "block"}} viewBox="0 0 20 20">
                            <circle cx="10" cy="10" r="8.5" fill="transparent" stroke="#d1d5db" strokeWidth="2.5"/>
                        </svg>
                    } */}

                </div>
            </div>
        )
    }

    if (displaySize === 'large') {
        return (
            <div className='relative'>
                <div className='h-8 w-8 rounded-full' />

                <div className='absolute top-0 left-0 h-8 w-8'>

                    {weekCompletionStatusIconKey === 'past-skipped' && 
                        <ForwardIcon className="-my-0.75 -ml-[3px] w-9 h-9 text-gray-400" />
                    }

                    {weekCompletionStatusIconKey === 'past-incomplete' && 
                        <svg width="30" height="30" style={{display: "block"}} viewBox="0 0 20 20">
                            <circle cx="10" cy="10" r="8.5" fill="transparent" stroke="#fb7185" strokeWidth="2.5"/> {/* Outer red ring */}
                            <circle cx="10" cy="10" r="5" fill="#fb7185"/> {/* Inner red circle */}
                        </svg>
                    }

                    {weekCompletionStatusIconKey === 'past-half-complete' && 
                        <svg width="30" height="30" style={{display: "block"}} viewBox="0 0 20 20">
                            <circle cx="10" cy="10" r="8.5" fill="transparent" stroke="#facc15" strokeWidth="2.5"/> {/* Outer yellow ring */}
                            <circle cx="10" cy="10" r="5" fill="#facc15"/> {/* Inner yellow circle */}
                        </svg>
                    }

                    {weekCompletionStatusIconKey === 'past-complete' && 
                        <svg width="30" height="30" style={{display: "block"}} viewBox="0 0 20 20">
                            <circle cx="10" cy="10" r="8.5" fill="transparent" stroke="#4ade80" strokeWidth="2.5"/> {/* Outer green ring */}
                            <circle cx="10" cy="10" r="5" fill="#4ade80"/> {/* Inner green circle */}
                        </svg>
                    }

                    {weekCompletionStatusIconKey === 'active-skipped' && 
                        <ForwardIcon className="-my-0.75 -ml-[3px] w-9 h-9 text-gray-400" />
                    }

                    {weekCompletionStatusIconKey === 'active' && 
                        <svg width="30" height="30" style={{display: "block"}} viewBox="0 0 20 20">
                            <circle cx="10" cy="10" r="8.5" fill="transparent" stroke="#99a1af" strokeWidth="2.5"/>
                        </svg>
                    }

                    {weekCompletionStatusIconKey === 'future' && 
                        <svg width="30" height="30" style={{display: "block"}} viewBox="0 0 20 20">
                            <circle cx="10" cy="10" r="8.5" fill="transparent" stroke="#99a1af" strokeWidth="2.5"/>
                        </svg>
                    }

                    {/* Faded */}
                    {/* {weekCompletionStatusIconKey === 'future' && 
                        <svg width="30" height="30" style={{display: "block"}} viewBox="0 0 20 20">
                            <circle cx="10" cy="10" r="8.5" fill="transparent" stroke="#d1d5db" strokeWidth="2.5"/>
                        </svg>
                    } */}

                </div>
            </div>
        )
    }
}